import { useFormikContext } from 'formik'

import { type ContractDto } from '@b-stock/contract-api-client'
import { CurrencyStringCents } from '@b-stock/fe-core/bstock-react'

import type { OfferingFormData } from '../types'
import { getRetailQuantityPrice } from './getRetailQuantityPrice'

export const LineAmount = ({
  contract,
  currency = 'USD',
  rowIndex,
}: {
  contract?: ContractDto | null
  currency?: string
  rowIndex: number
}) => {
  const { values } = useFormikContext<OfferingFormData>()
  // rowIndex is always valid - passed from table row renderer which only renders existing rows
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const itemRow = values.itemRows[rowIndex]!

  const lineAmount = getRetailQuantityPrice({
    offerAmountUnits: itemRow.offerAmountUnits,
    offerAmount: itemRow.offerAmount,
    offerQuantity: itemRow.offerQuantity,
    unitRetail: itemRow.item.attributes.unitRetail,
    itemQuantity: itemRow.item.quantity,
    contract,
  })

  return <CurrencyStringCents currency={currency} value={lineAmount} />
}
